import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    active: { type: Boolean },
    backgroundColor: null,
    color: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: "click"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  active?: boolean;
  backgroundColor?: string;
  color?: string;
}



const style = computed(() => ({
  ...(props.backgroundColor ? { backgroundColor: props.backgroundColor } : {}),
  ...(props.color ? { color: props.color } : {}),
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'icon-button': true, active: props.active }),
    style: _normalizeStyle(_unref(style)),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})